import React, { Component } from "react";
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { withRouter } from '../../common/with-router';
import {Card} from "react-bootstrap";

class Pagina404 extends Component {
    render() {
        const { t } = this.props;

        return (
            <div>
                <h4 className="page-title">{t('errors:notFound.title')}</h4>
                <Card border="light">
                    <Card.Body>                    
                        <p className="mt-3">{t('errors:notFound.text')}</p>                 
                    </Card.Body>                
                </Card>
            </div>
        );
    }
}

Pagina404.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation(['errors'])(withRouter(Pagina404));